// Help system data for the Sprite Editor
export const helpSections = {
    frameEditing: {
        title: "📝 Frame Editing",
        items: [
            { action: "Left Click Frame", description: "Select and manipulate frame" },
            { action: "Drag Frame Body", description: "Move frame position" },
            { action: "Drag Handles", description: "Resize frame (8 resize handles)" },
            { action: "Alt + Drag Frame", description: "Duplicate frame to new position" },
            { action: "Middle Click/Shift+Drag", description: "Create new frame" },
            { action: "Right Click", description: "Context menu with options" }
        ]
    },
    navigation: {
        title: "🖱️ Navigation",
        items: [
            { action: "Ctrl + Left Drag", description: "Pan around spritesheet" },
            { action: "Mouse Wheel", description: "Zoom in/out" },
            { action: "Zoom Dropdown", description: "Set specific zoom level" },
            { action: "Fit to View", description: "Reset zoom to 100%" }
        ]
    },
    keyboardShortcuts: {
        title: "⌨️ Keyboard Shortcuts",
        items: [
            { action: "Ctrl+Z", description: "Undo last action (50 action history)" },
            { action: "Ctrl+Y", description: "Redo action" },
            { action: "G", description: "Toggle grid overlay" },
            { action: "L", description: "Lock/Unlock selected frame" },
            { action: "Arrow Keys", description: "Move selected frame (1px steps)" },
            { action: "H or ?", description: "Show this help" },
            { action: "Escape", description: "Deselect frame" },
            { action: "Delete", description: "Delete selected frame" }
        ]
    },
    contextMenu: {
        title: "🖱️ Right-Click Menu",
        items: [
            { action: "Select/Duplicate/Delete", description: "Frame management options" },
            { action: "Lock/Unlock", description: "Individual frame protection" },
            { action: "Create New Frame", description: "Create frame at cursor position" },
            { action: "Reset Pan & Zoom", description: "Return to default view" },
            { action: "Toggle Grid", description: "Show/hide grid overlay" },
            { action: "Export/Help", description: "Additional utility options" }
        ]
    },
    advancedFeatures: {
        title: "🔧 Advanced Features",
        items: [
            { action: "Pixel-perfect Snapping", description: "Automatic alignment to pixel boundaries" },
            { action: "Unlimited Undo/Redo", description: "Full action history with 50 step memory" },
            { action: "Frame Duplication", description: "Copy frames with Alt+drag or context menu" },
            { action: "Real-time Coordinates", description: "Live position and size display" },
            { action: "Context-sensitive Menus", description: "Dynamic options based on selection" },
            { action: "Professional Resize Handles", description: "8-point resize system" },
            { action: "Arrow Key Movement", description: "Precision frame positioning" }
        ]
    },
    exportData: {
        title: "💾 Export & Data",
        items: [
            { action: "Export JSON", description: "Download updated spritesheet JSON" },
            { action: "Change Tracking", description: "All modifications preserved with undo history" },
            { action: "Frame Management", description: "Creation, modification, deletion tracking" },
            { action: "Auto-save State", description: "Preserve work during editing sessions" }
        ]
    }
};

export const helpConfig = {
    title: "Sprite Editor Help",
    version: "1.0.0",
    lastUpdated: "2025-12-26"
};